import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import { workOrdersListSearchSchema } from '&/features/work-orders/lib/work-orders-list-search';
import { WORK_ORDERS_LIST_PERMISSION, WORK_ORDERS_PATH } from '&/features/work-orders/paths';
import { requireModule } from '&/lib/module-gate';

/**
 * The work-order full-page layout (SWOOP-254). Un-nested from the list route via the trailing-underscore
 * segment `work-orders_`, so it renders standalone with its own header + tab bar around an `<Outlet />`
 * (the tab bodies are its nested routes). Gated exactly as the list route: the Maintenance module
 * (not-found otherwise) and `work-orders:list` (redirect otherwise). `dynamic` because the page titles
 * the browser tab with the work order number. Carries the list's search schema so the breadcrumb and
 * tab links can return to `/work-orders` with its tab / filters / page intact.
 */
export const Route = createFileRoute('/_authenticated/work-orders_/$workOrderId')({
  beforeLoad: ({ context }): void => {
    requireModule(context.entitlement, WORK_ORDERS_PATH);
    if (context.permissions.isReady && !context.permissions.hasPermission(WORK_ORDERS_LIST_PERMISSION)) {
      throw redirect({ to: '/' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/work-orders/pages/work-order-page-layout')),
  staticData: { dynamic: true },
  validateSearch: (search) => workOrdersListSearchSchema.parse(search),
});
